import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

const ProtectedLaborOperationsRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f5f5f2]" dir="rtl">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#e2d7c4] border-t-[#b38b4c]" />
      </div>
    );
  }

  return isAuthenticated
    ? children
    : <Navigate to="/cases/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
};

export default ProtectedLaborOperationsRoute;
